import UmIM from './index.vue'

UmIM.install = (Vue) => {
  Vue.component(UmIM.name, UmIM)
}

export default UmIM
